import { Draft } from 'immer';
import { produce } from "immer";
import { SeatTogglePayload } from "@/components/mapa/MapaViewer1";
import { EntradaSeleccionada } from "@/schemas/checkout.schema";
import { EventoStore } from "./evento";
import { Entrada } from '@/types';

export interface EntradasSlice {
    state: EntradaSeleccionada[];
    set: (entradas: EntradaSeleccionada[]) => void;
    setAsiento: (asiento: SeatTogglePayload) => void;
    removeAsiento: (asiento: SeatTogglePayload) => void;
    clear: () => void;
}

export const createEntradasSlice = (set: any): EntradasSlice => ({
    state: [],
    set: (entradas) => set(produce((state: Draft<EventoStore>) => { state.entradas.state = entradas; })),
    setAsiento: (asiento) => set(produce((state: Draft<EventoStore>) => {
        const funcion = state.funcion.state;
        if (!funcion) return;

        const entradasByTipo = funcion.entradas.reduce((acc, entrada) => {
            acc[entrada.tipoEntradaId] = entrada;
            return acc;
        }, {} as Record<string, Entrada>);

        const entradas = state.entradas.state;
        const existing = entradas.findIndex(a => a.tipoEntradaId === asiento.tipoEntradaId);

        if (existing !== -1) {
            entradas[existing].cantidad += 1;
            entradas[existing].asientos = [
                ...entradas[existing].asientos,
                { seatId: asiento.seatId, mesaId: asiento.mesaId }
            ];
        } else {
            const tipoEntrada = entradasByTipo[asiento.tipoEntradaId].tipo_entrada!;
            entradas.push({
                tipoEntradaId: asiento.tipoEntradaId,
                cantidad: 1,
                nombre: tipoEntrada.nombre,
                precio: entradasByTipo[asiento.tipoEntradaId].precio,
                descripcion: tipoEntrada.descripcion,
                asientos: [{ seatId: asiento.seatId, mesaId: asiento.mesaId }]
            });
        }
    })),
    removeAsiento: (asiento) => set(produce((state: Draft<EventoStore>) => {
        const entradas = state.entradas.state;
        const existing = entradas.findIndex(a => a.tipoEntradaId === asiento.tipoEntradaId);

        if (existing !== -1) {
            entradas[existing].cantidad -= 1;

            // Si seatId es null (compra sin mapa), solo quitar uno de los asientos null
            if (asiento.seatId === null) {
                const nullIndex = entradas[existing].asientos.findIndex(a => a.seatId === null);
                if (nullIndex !== -1) {
                    entradas[existing].asientos.splice(nullIndex, 1);
                }
            } else {
                // Compra con mapa: filtrar por seatId específico
                entradas[existing].asientos = entradas[existing].asientos.filter(
                    a => !(a.seatId === asiento.seatId && a.mesaId === asiento.mesaId)
                );
            }

            // Si la cantidad llega a 0, eliminar la entrada
            if (entradas[existing].cantidad === 0) {
                entradas.splice(existing, 1);
            }
        }
    })),
    clear: () => set(produce((state: Draft<EventoStore>) => { state.entradas.state = []; })),
});